var _path, _mask, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButtonBlackOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0.349609C43.2707 0.349609 55.6504 12.7293 55.6504 28C55.6504 43.2707 43.2707 55.6504 28 55.6504C12.7293 55.6504 0.349609 43.2707 0.349609 28C0.349609 12.7293 12.7293 0.349609 28 0.349609Z",
    stroke: "black",
    strokeWidth: 0.7
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2490_15149",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56ZM23.625 38.2705L39.375 29.4672C40.5417 28.8151 40.5417 27.1849 39.375 26.5328L23.625 17.7295C22.4583 17.0774 21 17.8925 21 19.1967V36.8033C21 38.1075 22.4583 38.9226 23.625 38.2705Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2490_15149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56ZM23.625 38.2705L39.375 29.4672C40.5417 28.8151 40.5417 27.1849 39.375 26.5328L23.625 17.7295C22.4583 17.0774 21 17.8925 21 19.1967V36.8033C21 38.1075 22.4583 38.9226 23.625 38.2705Z",
    fill: "#367FFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 29.4672L39.7165 30.0782L39.375 29.4672ZM23.625 38.2705L23.2835 37.6595H23.2835L23.625 38.2705ZM39.375 26.5328L39.0335 27.1438H39.0335L39.375 26.5328ZM23.625 17.7295L23.9665 17.1185L23.625 17.7295ZM56 28H55.3C55.3 43.0774 43.0774 55.3 28 55.3V56V56.7C43.8506 56.7 56.7 43.8506 56.7 28H56ZM28 0V0.7C43.0774 0.7 55.3 12.9226 55.3 28H56H56.7C56.7 12.1494 43.8506 -0.7 28 -0.7V0ZM0 28H0.7C0.7 12.9226 12.9226 0.7 28 0.7V0V-0.7C12.1494 -0.7 -0.7 12.1494 -0.7 28H0ZM28 56V55.3C12.9226 55.3 0.7 43.0774 0.7 28H0H-0.7C-0.7 43.8506 12.1494 56.7 28 56.7V56ZM39.375 29.4672L39.0335 28.8562L23.2835 37.6595L23.625 38.2705L23.9665 38.8815L39.7165 30.0782L39.375 29.4672ZM39.375 26.5328L39.0335 27.1438C39.7222 27.5288 39.7222 28.4712 39.0335 28.8562L39.375 29.4672L39.7165 30.0782C41.3612 29.159 41.3612 26.841 39.7165 25.9218L39.375 26.5328ZM23.625 17.7295L23.2835 18.3405L39.0335 27.1438L39.375 26.5328L39.7165 25.9218L23.9665 17.1185L23.625 17.7295ZM21 19.1967H21.7C21.7 18.4653 22.5496 17.9303 23.2835 18.3405L23.625 17.7295L23.9665 17.1185C22.3671 16.2245 20.3 17.3197 20.3 19.1967H21ZM21 36.8033H21.7V19.1967H21H20.3V36.8033H21ZM23.625 38.2705L23.2835 37.6595C22.5496 38.0697 21.7 37.5347 21.7 36.8033H21H20.3C20.3 38.6803 22.3671 39.7755 23.9665 38.8815L23.625 38.2705Z",
    fill: "black",
    mask: "url(#path-2-inside-1_2490_15149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2490_15149",
    x: 0,
    y: 0,
    width: 56,
    height: 56.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2490_15149"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonBlackOutline);
export default __webpack_public_path__ + "static/media/play_button_black_outline.6c5d8d53d49b08835a788ac0761bfc7b.svg";
export { ForwardRef as ReactComponent };